import _ from 'lodash';

const EQUAL = 'eq';
const NOT_EQUAL = 'ne';
const GREATER_THAN = 'gt';
const GREATER_THAN_OR_EQUAL = 'ge';
const LESS_THAN = 'lt';
const LESS_THAN_OR_EQUAL = 'le';
const LIKE = 'li';
const NOT_LIKE = 'nl';
const IN = 'in';
const NOT_IN = 'ni';
const BETWEEN = 'be';
const NOT_BETWEEN = 'nb';
const IS = 'is';
const NOT = 'no';

const FILTER_SEPARATOR = ',';
const GROUP_SEPARATOR = ';';

export class FilterQueryParams {
    constructor () {
        this.filters = {};
    }

    static get EQUAL () { return EQUAL; }
    static get NOT_EQUAL () { return NOT_EQUAL; }
    static get GREATER_THAN () { return GREATER_THAN; }
    static get GREATER_THAN_OR_EQUAL () { return GREATER_THAN_OR_EQUAL; }
    static get LESS_THAN () { return LESS_THAN; }
    static get LESS_THAN_OR_EQUAL () { return LESS_THAN_OR_EQUAL; }
    static get LIKE () { return LIKE; }
    static get NOT_LIKE () { return NOT_LIKE; }
    static get IN () { return IN; }
    static get NOT_IN () { return NOT_IN; }
    static get BETWEEN () { return BETWEEN; }
    static get NOT_BETWEEN () { return NOT_BETWEEN; }
    static get IS () { return IS; }
    static get NOT () { return NOT; }

    equal (key, value) {
        return this.add(key, EQUAL, value);
    }

    notEqual (key, value) {
        return this.add(key, NOT_EQUAL, value);
    }

    greaterThan (key, value) {
        return this.add(key, GREATER_THAN, value);
    }

    greaterThanOrEqual (key, value) {
        return this.add(key, GREATER_THAN_OR_EQUAL, value);
    }

    lessThan (key, value) {
        return this.add(key, LESS_THAN, value);
    }

    lessThanOrEqual (key, value) {
        return this.add(key, LESS_THAN_OR_EQUAL, value);
    }

    like (key, value) {
        return this.add(key, LIKE, value);
    }

    notLike (key, value) {
        return this.add(key, NOT_LIKE, value);
    }

    in (key, value) {
        _.each(_.isArray(value) ? value : [value], v => this.append(key, IN, v));
        return this;
    }

    notIn (key, value) {
        _.each(_.isArray(value) ? value : [value], v => this.append(key, NOT_IN, v));
        return this;
    }

    between (key, from, to) {
        this.add(key, BETWEEN, []);
        this.append(key, BETWEEN, from);
        this.append(key, BETWEEN, to);
        return this;
    }

    notBetween (key, from, to) {
        this.add(key, NOT_BETWEEN, []);
        this.append(key, NOT_BETWEEN, from);
        this.append(key, NOT_BETWEEN, to);
        return this;
    }

    is (key, value) {
        return this.add(key, IS, value);
    }

    not (key, value) {
        return this.add(key, NOT, value);
    }

    add (key, condition, value) {
        if (!this.filters[key]) {
            this.filters[key] = {};
        }
        this.filters[key][condition] = value;
        return this;
    }

    append (key, condition, value) {
        if (!this.filters[key]) {
            this.filters[key] = {};
        }

        const filter = this.filters[key];

        if (filter) {
            if (!filter[condition]) {
                filter[condition] = [];
            }

            filter[condition].push(value);
        }
        return this;
    }

    remove (key, condition) {
        if (!this.filters[key]) {
            return this;
        }

        if (!condition) {
            delete this.filters[key];
        }

        const filter = this.filters[key];

        if (filter && filter[condition]) {
            delete filter[condition];
        }
        return this;
    }

    build () {
        if (!_.size(this.filters)) {
            return '';
        }

        const result = [];

        _.each(this.filters, (filter, key) => {
            _.each(filter, (value, condition) => {
                const builder = [];

                builder.push(key);
                builder.push(` ${condition} `);

                switch (condition) {
                    case IN:
                    case NOT_IN:
                    case BETWEEN:
                    case NOT_BETWEEN:
                        builder.push(`[${_.join(value, GROUP_SEPARATOR)}]`);
                        break;

                    default:
                        builder.push(value);
                        break;
                }

                result.push(builder.join(''));
            });
        });
        return _.join(result, FILTER_SEPARATOR);
    }
}
